<template>
  <div>
    <div v-if="changeInfo.showHoseZL">
      <van-field
        v-model="changeInfo.currentHouseZl"
        label="原地址"
        size="large"
        :readonly="true"
        label-width="90px"
      />
      <van-field
        v-model="applicationInfo.bHNR"
        v-validate="{required:true}"
        :data-vv-scope="dataVvScope"
        required
        data-vv-as="新地址"
        label="新地址"
        size="large"
        :readonly="!isEditable"
        label-width="90px"
      />
    </div>
    <div v-if="changeInfo.showHoseMj">
      <van-field
        v-model="changeInfo.currentHouseMj"
        label="原面积"
        size="large"
        :readonly="true"
        label-width="90px"
      />
      <van-field
        v-model="applicationInfo.bHNR"
        v-validate="{required:true}"
        :data-vv-scope="dataVvScope"
        required
        data-vv-as="新面积"
        label="新面积"
        size="large"
        :readonly="!isEditable"
        label-width="90px"
      />
    </div>
    <div v-if="changeInfo.showHoseXz">
      <van-field
        v-model="changeInfo.currentHouseXz"
        label="原性质"
        size="large"
        :readonly="true"
        label-width="90px"
      />
      <van-field
        v-model="applicationInfo.bHNR"
        v-validate="{required:true}"
        :data-vv-scope="dataVvScope"
        required
        data-vv-as="新性质"
        label="新性质"
        size="large"
        :readonly="!isEditable"
        label-width="90px"
      />
    </div>
    <div v-if="changeInfo.showHoseYt">
      <van-field
        v-model="changeInfo.currentHouseYt"
        label="原用途"
        size="large"
        :readonly="true"
        label-width="90px"
      />
      <van-field
        v-model="applicationInfo.bHNR"
        v-validate="{required:true}"
        :data-vv-scope="dataVvScope"
        required
        data-vv-as="新用途"
        label="新用途"
        size="large"
        :readonly="!isEditable"
        label-width="90px"
      />
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  components: {},
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    dataVvScope: {
      type: String,
      default: null
    },
    applicationInfo: {
      type: Object,
      default: () => {
        return {
          businessTypeId: '',
          businessTypeName: '',
          businessTypeAlias: '',
          businessTypeCode: '',
          registrationItemId: '',
          registrationItemName: '',
          registrationItemAlias: '',
          registrationItemCode: '',
          applicantName: '',
          applicantIdNumber: '',
          applicantMobilePhone: '',
          remark: '',
          jJQLRs: [],
          qlrList: [], // 权利人列表
          ywrList: [], // 义务人列表
          bDCQZH: '', // 产权证号
          bDCDYH: '', // 不动产单元号
          sQZT: '', // 申请主体
          bHNR: '' // 变化内容
        }
      }
    },
    changeInfo: {
      type: Object,
      default: () => {
        return {
          showHoseZL: false,
          showHoseMj: false,
          showHoseYt: false,
          showHoseXz: false,
          currentHouseZl: '', // 当前房屋地址
          currentHouseMj: '', // 当前房屋面积
          currentHouseYt: '', // 当前房屋用途
          currentHouseXz: '' // 当前房屋性质
        }
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    validationErrors() {
      return this.$validator.errors
    }
  },
  watch: {
    validationErrors: {
      handler(newValue, oldValue) {
        this.$emit('validate', !newValue.any())
      },
      deep: true
    }
  },
  mounted() {
    this.$validator.validateAll(this.dataVvScope)
  }
}
</script>

<style lang="scss" scoped>
</style>
